import React from 'react';
import { HERO_IMAGE } from '../data/mock';

const Hero = () => (
  <section className="relative w-full overflow-hidden">
    <div className="relative w-full h-[45vh] md:h-[62vh] lg:h-[72vh]">
      <img
        src={HERO_IMAGE}
        alt="Cathedral interior of All Saints Catholic Parish"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/25" />
    </div>
  </section>
);

export default Hero;
